import { useCallback, useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Dialog, Toast } from "react-vant"
import finger from "@/assets/images/finger_up.png"
import refining_img from '@/assets/images/cards/refining.svg'
import "./index.less"
import { HighlightPercentages_1 } from "../../utils"
import ButtonComp from "../common/ButtonComp"
import { putGuideTypeList, getGuideTypeList } from "@/api/account.js"
import { useDispatch } from "react-redux"
import { changeGuideTypeList } from "../../store/module/progress"

const CardGuide = () => {
  const [visible, setVisible] = useState(true)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navList = [
    {
      name: t("card.index.sale"),
      id: 1,
    },
    {
      name: t("card.index.display"),
      id: 2,
    },
    {
      name: t("card.index.mine"),
      id: 3,
    },
  ]

  const cardsGuideText = [
    {
      text: t("cardsGuideText.text"),
      id: 1,
    },
    {
      text: t("cardsGuideText.text_1"),
      id: 2,
    },
    {
      text: t("cardsGuideText.text_2"),
      id: 3,
    },
  ]

  const [add, setAdd] = useState(0)

  const getGuideType = async () => {
    const { code, data } = await getGuideTypeList()
    if (code == 0) {
      let obj: any = {}
      if (Array.isArray(data.tasks)) {
        data.tasks.forEach((el: any) => {
          obj[el.code] = el.status
        });
        dispatch(changeGuideTypeList({ ...data, tasks: obj }))
      }else {
        dispatch(changeGuideTypeList(data))
      }
    }
  }


  return (
    <Dialog
      visible={visible}
      showConfirmButton={false}
      showCancelButton={false}
      closeOnClickOverlay={false}
      onClose={() => { setVisible(false) }}
      width={'100%'}
    >
      <div className="h-[100vh] w-[100%]" onClick={async () => {
        if (add < 2) {
          setAdd(add + 1)
        } else {
          const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
          })
          await putGuideTypeList('cardGuide')
          await getGuideType()
          toast.clear()
        }
      }}>
        {/* 第一步 */}

        {add == 0 && <div className='max-md:fixed md:absolute px-4 top-[50px] pt-[5px] left-0 w-full z-[99]'>
          <div className={`text-center h-[36px] grid grid-cols-3 !w-[100%]  z-[100] rounded-[10px] gap-0 `}>
            <div style={{ background: 'linear-gradient( 90deg, #00E49F 0%, #54ADFF 100%)', borderRadius: '10px' }} className="flex items-center justify-center w-[100%]">
              <p className=" text-[14px] text-[#fff] flex items-center justify-center leading-[18px] ">{navList[0].name}&nbsp;&nbsp;42.5k
                <svg className={`ml-[6px]`} width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
                      <stop stopColor={'#fff'} offset="0%"></stop>
                      <stop stopColor={'#fff'} offset="100%"></stop>
                    </linearGradient>
                  </defs>
                  <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="10-cards-sale" transform="translate(-279.000000, -60.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
                      <g id="编组" transform="translate(279.000000, 60.000000)">
                        <path d="M11.7148409,2.30618042 C11.4911427,2.21958428 11.2443829,2.34576723 11.1659732,2.58576224 L10.8338852,3.58532915 C10.444143,2.64266829 9.8283965,1.8138195 9.04429979,1.19280144 C6.55133349,-0.786538945 2.99983662,-0.247168689 1.13184152,2.40019909 C0.227824132,3.68182199 -0.154999551,5.26034596 0.0571677919,6.84381828 C0.269335135,8.43471312 1.05573801,9.84251898 2.26647558,10.8049732 C3.28118897,11.6090803 4.46886487,12 5.6473161,12 C7.3700227,12 9.06966762,11.1711512 10.1789338,9.60004977 C10.6701474,8.90480646 11.0045416,8.12791535 11.1775041,7.28669569 C11.2282397,7.03680397 11.0806451,6.7918606 10.8500284,6.73742873 C10.6194117,6.68299687 10.388795,6.83886993 10.3380593,7.08876165 C10.1927708,7.79885002 9.90911231,8.4569807 9.4940023,9.04336029 C7.90966572,11.2874375 4.89550572,11.7451599 2.7784446,10.0627206 C1.75220038,9.24871686 1.08802434,8.05863844 0.908143328,6.71268697 C0.728262313,5.37415803 1.05112567,4.04057745 1.81677305,2.95688857 C3.39880347,0.712811404 6.41065731,0.252614756 8.53002459,1.93505409 C9.29797813,2.54370126 9.87221366,3.38739511 10.1835462,4.33995266 L8.70529326,3.72140878 C8.48390124,3.62986429 8.23483523,3.74615054 8.14720089,3.98367139 C8.05956655,4.22119224 8.17026256,4.4884032 8.39165457,4.58242186 L10.568676,5.49539262 C10.6194117,5.5176602 10.6724535,5.5275569 10.7254954,5.5275569 C10.7324139,5.5275569 10.7393324,5.52508272 10.7462509,5.52508272 C10.762394,5.5275569 10.7785372,5.53497942 10.7946804,5.53497942 C10.9722552,5.53497942 11.1382992,5.416219 11.2005657,5.22818165 L11.9754378,2.90245669 C12.0538474,2.65751334 11.9385391,2.39277656 11.7148409,2.30618042 Z" id="路径"></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </p>
            </div>
            <div style={{ background: 'linear-gradient( 90deg, #00E49F 0%, #54ADFF 100%)', borderRadius: '10px' }} className="flex items-center justify-center w-[100%]">
              <p className=" text-[14px] text-[#fff] flex items-center justify-center leading-[18px] ">{navList[1].name}</p>
            </div>
          </div>
          <div className=" triangle-up rounded-[10px] mt-[50px] w-[250px] relative p-[10px] bg-white">
            <img className=" w-[31px] h-11 absolute left-[40px] -top-[50px] z-10" src={finger} alt="" />
            <p className="text-[16px] text-[#333] leading-[19px] font-semibold"
              dangerouslySetInnerHTML={{ __html: HighlightPercentages_1(cardsGuideText[0].text) }}></p>
          </div>
          <p className="text-[14px] text-[#fff] leading-[20px] font-semibold mt-1.5">{t("agentsGuideText.click_tip")}</p>
        </div>}


        {/* 第二步 */}

        {add == 1 && <div className='max-md:fixed md:absolute px-4 top-[50px] pt-[5px] left-0 w-full z-[99]'>
          <div className={`text-center h-[36px] grid grid-cols-3 !w-[100%] z-[100] rounded-[10px] gap-0 `}>
            <div style={{ background: 'linear-gradient( 90deg, #00E49F 0%, #54ADFF 100%)', borderRadius: '10px' }} className="flex opacity-0 items-center justify-center w-[100%]">

            </div>
            <div style={{ background: 'linear-gradient( 90deg, #00E49F 0%, #54ADFF 100%)', borderRadius: '10px' }} className="flex opacity-0 items-center justify-center w-[100%]">
            </div>
            <div style={{ background: 'linear-gradient( 90deg, #00E49F 0%, #54ADFF 100%)', borderRadius: '10px' }} className="flex items-center justify-center w-[100%]">
              <p className=" text-[14px] text-[#fff] flex items-center justify-center leading-[18px] ">{navList[2].name}&nbsp;&nbsp;42.5k
                <svg className={`ml-[6px]`} width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                  <defs>
                    <linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
                      <stop stopColor={'#fff'} offset="0%"></stop>
                      <stop stopColor={'#fff'} offset="100%"></stop>
                    </linearGradient>
                  </defs>
                  <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="10-cards-sale" transform="translate(-279.000000, -60.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
                      <g id="编组" transform="translate(279.000000, 60.000000)">
                        <path d="M11.7148409,2.30618042 C11.4911427,2.21958428 11.2443829,2.34576723 11.1659732,2.58576224 L10.8338852,3.58532915 C10.444143,2.64266829 9.8283965,1.8138195 9.04429979,1.19280144 C6.55133349,-0.786538945 2.99983662,-0.247168689 1.13184152,2.40019909 C0.227824132,3.68182199 -0.154999551,5.26034596 0.0571677919,6.84381828 C0.269335135,8.43471312 1.05573801,9.84251898 2.26647558,10.8049732 C3.28118897,11.6090803 4.46886487,12 5.6473161,12 C7.3700227,12 9.06966762,11.1711512 10.1789338,9.60004977 C10.6701474,8.90480646 11.0045416,8.12791535 11.1775041,7.28669569 C11.2282397,7.03680397 11.0806451,6.7918606 10.8500284,6.73742873 C10.6194117,6.68299687 10.388795,6.83886993 10.3380593,7.08876165 C10.1927708,7.79885002 9.90911231,8.4569807 9.4940023,9.04336029 C7.90966572,11.2874375 4.89550572,11.7451599 2.7784446,10.0627206 C1.75220038,9.24871686 1.08802434,8.05863844 0.908143328,6.71268697 C0.728262313,5.37415803 1.05112567,4.04057745 1.81677305,2.95688857 C3.39880347,0.712811404 6.41065731,0.252614756 8.53002459,1.93505409 C9.29797813,2.54370126 9.87221366,3.38739511 10.1835462,4.33995266 L8.70529326,3.72140878 C8.48390124,3.62986429 8.23483523,3.74615054 8.14720089,3.98367139 C8.05956655,4.22119224 8.17026256,4.4884032 8.39165457,4.58242186 L10.568676,5.49539262 C10.6194117,5.5176602 10.6724535,5.5275569 10.7254954,5.5275569 C10.7324139,5.5275569 10.7393324,5.52508272 10.7462509,5.52508272 C10.762394,5.5275569 10.7785372,5.53497942 10.7946804,5.53497942 C10.9722552,5.53497942 11.1382992,5.416219 11.2005657,5.22818165 L11.9754378,2.90245669 C12.0538474,2.65751334 11.9385391,2.39277656 11.7148409,2.30618042 Z" id="路径"></path>
                      </g>
                    </g>
                  </g>
                </svg>
              </p>
            </div>
          </div>
          <div className=" w-full flex flex-row justify-end">
            <div className=" triangle-up New_1 rounded-[10px] mt-[50px] w-[250px] relative p-[10px] bg-white">
              <img className=" w-[31px] h-11 absolute left-[183px] -top-[50px] z-10" src={finger} alt="" />
              <p className="text-[16px] text-[#333] leading-[19px] font-semibold"
                dangerouslySetInnerHTML={{ __html: HighlightPercentages_1(cardsGuideText[1].text) }}></p>
            </div>
          </div>
        </div>}


        {/* 第三步 */}
        {add == 2 && <div className="bottom-[135px] flex flex-col-reverse absolute z-10 left-[50%] translate-x-[-50%]">
          <ButtonComp title={t("shop.refining")} callBack={() => {
          }}>
            <img className='h-[14px] w-[14px] mr-1' src={refining_img} alt="" />
          </ButtonComp>
          <div className=" triangle-down rounded-[10px] mb-[50px] w-[250px] relative p-[10px] bg-white">
            <img className=" w-[31px] finger_down h-11 absolute left-[50%] rotate-180 -translate-x-[50%] -bottom-[50px] z-10" src={finger} alt="" />
            <p className="text-[16px] text-[#333] leading-[19px] font-semibold"
              dangerouslySetInnerHTML={{ __html: HighlightPercentages_1(cardsGuideText[2].text) }}></p>
          </div>
        </div>}
        <p onClick={async () => {
          const toast = Toast.loading({
            message: t("other.loading"),
            forbidClick: true,
            duration: 0
          })
          await putGuideTypeList('cardGuide')
          await getGuideType()
          toast.clear()
        }} className=" absolute underline bottom-10 left-[50%] translate-x-[-50%] text-[14px] text-[#fff] leading-[18px] font-semibold">{t("skip_the_tutorial")}</p>
      </div>
    </Dialog>
  )
}
export default CardGuide
